import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { initScrollAnimations } from '../../utils/scrollAnimation';
import './Services.css';

// Импортируем картинки
import rvpImg from '../../assets/images/rvp.png';
import vnzhImg from '../../assets/images/vnzh.png';
import rfImg from '../../assets/images/rf.png';
import translateImg from '../../assets/images/translate.png';

const Services = () => {
  useEffect(() => {
    initScrollAnimations();
  }, []);

  const services = [
    {
      id: 'rvp',
      image: rvpImg,
      title: 'Разрешение на временное проживание (РВП)',
      description: 'Оформление РВП и юридическая поддержка на всех этапах',
      features: ['Подготовка документов', 'Сопровождение', 'Консультации']
    },
    {
      id: 'vnzh',
      image: vnzhImg,
      title: 'Вид на жительство (ВНЖ)',
      description: 'Полная помощь в оформлении и получении ВНЖ в России',
      features: ['Анализ документов', 'Подача заявления', 'Отслеживание статуса']
    },
    {
      id: 'citizenship',
      image: rfImg,
      title: 'Гражданство РФ',
      description: 'Профессиональное содействие в оформлении гражданства РФ',
      features: ['Полный пакет документов', 'Юридическая поддержка', 'Ускоренная процедура']
    },
    {
      id: 'translation',
      image: translateImg,
      title: 'Бюро Переводов',
      description: 'Нотариально заверенный перевод документов',
      features: ['Быстрые сроки', 'Все языки', 'Нотариальное заверение']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header scroll-fade">
          <h2>Наши услуги</h2>
          <p>Комплексная помощь в решении миграционных вопросов</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card scroll-fade"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>
              
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              
              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>

              <Link 
                to={`/service/${service.id}`}
                className="service-link"
              >
                Подробнее →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;